import React, { useEffect, useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  IconButton,
  Typography,
  Divider,
  Drawer,
  Popover,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import StarBorder from "@mui/icons-material/StarBorder";
import HomeIcon from "@mui/icons-material/Home";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "./../../contexts/AuthContext";
import LogoIcon from "./../../assets/logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FavoriteIcon from "@mui/icons-material/Favorite";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EventIcon from "@mui/icons-material/Event";
import QuizIcon from "@mui/icons-material/Quiz";
import WavingHandIcon from "@mui/icons-material/WavingHand";
import NumbersIcon from "@mui/icons-material/Numbers";
import StyleIcon from "@mui/icons-material/Style";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import BlurCircularIcon from "@mui/icons-material/BlurCircular";
import StarIcon from "@mui/icons-material/Star";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import FlakyIcon from "@mui/icons-material/Flaky";
import TodayIcon from "@mui/icons-material/Today";
import SdCardIcon from "@mui/icons-material/SdCard";
import * as links from "./../../routes/links";
import { useAppContext } from "../../contexts/AppContext";
import Swal from "sweetalert2";
interface MenuItem {
  id: number;
  name: string;
  icon: React.ReactNode;
  subItems?: MenuItem[];
  link?: string;
}

export const menuItems: MenuItem[] = [
  {
    id: 1,
    name: "Zodiac",
    icon: <BlurCircularIcon />,
    subItems: [
      {
        id: 11,
        name: "What is the zodiac?",
        icon: <WavingHandIcon />,
        link: links.ZODIAC_WHAT_IS,
      },
      {
        id: 12,
        name: "Zodiac list",
        icon: <FormatListBulletedIcon />,
        link: links.ZODIAC_LIST,
      },
      // {
      //   id: 12,
      //   name: "Zodiac Sign Quiz",
      //   icon: <QuizIcon />,
      //   link: links.ZODIAC_SIGN_QUIZ,
      // },
      // {
      //   id: 13,
      //   name: "Constellations Quiz",
      //   icon: <QuizIcon />,
      //   link: links.ZODIAC_CONSTELLATIONS_QUIZ,
      // },

      {
        id: 14,
        name: "Zodiac Love Compatibility",
        icon: <FavoriteIcon />,
        link: links.ZODIAC_LOVE_COMPATIBILITY,
      },
      {
        id: 15,
        name: "Zodiac Calendar",
        icon: <CalendarMonthIcon />,
        link: links.ZODIAC_CALENDAR,
      },
      {
        id: 16,
        name: "Ranking Of Constellations",
        icon: <StarIcon />,
        link: links.ZODIAC_RANKING_OF_CONSTELLATIONS,
      },
      {
        id: 17,
        name: "Daily Horoscope",
        icon: <TodayIcon />,
        link: links.ZODIAC_DAILY_HOROSCOPE,
      },
    ],
  },
  {
    id: 2,
    name: "Numerology",
    icon: <NumbersIcon />,
    subItems: [
      {
        id: 21,
        name: "What is numerology?",
        icon: <LabelImportantIcon />,
        link: links.NUMEROLOGY_WHAT_IS,
      },
      {
        id: 22,
        name: "Meaning of numbers",
        icon: <LabelImportantIcon />,
        link: links.NUMEROLOGY_MEANING_OF_NUMBERS,
      },
      {
        id: 23,
        name: "Meaning of angel numbers",
        icon: <LabelImportantIcon />,
        link: links.NUMEROLOGY_MEANING_OF_ANGEL_NUMBERS,
      },
      {
        id: 24,
        name: "Master numbers",
        icon: <LabelImportantIcon />,
        link: links.NUMEROLOGY_MASTER_NUMBERS,
      },
      {
        id: 25,
        name: "Numerology Indicators - Life Path",
        icon: <LabelImportantIcon />,
        link: links.NUMEROLOGY_INDICATORS_LIFE_PATH,
      },
      {
        id: 26,
        name: "Numerology Indicators - Expression",
        icon: <LabelImportantIcon />,
        link: links.NUMEROLOGY_INDICATORS_EXPRESSION,
      },
      {
        id: 27,
        name: "Numerology Indicators - Birthday",
        icon: <LabelImportantIcon />,
        link: links.NUMEROLOGY_INDICATORS_BIRTHDAY,
      },
      {
        id: 28,
        name: "Numerology Indicators - Name",
        icon: <LabelImportantIcon />,
        link: links.NUMEROLOGY_INDICATORS_NAME,
      },
      {
        id: 28,
        name: "Numerology Indicators - Compatibility",
        icon: <LabelImportantIcon />,
        link: links.NUMEROLOGY_INDICATORS_COMPATIBILITY,
      },
      {
        id: 29,
        name: "Daily Number",
        icon: <TodayIcon />,
        link: links.NUMEROLOGY_DAILY_NUMBER,
      },
    ],
  },
  {
    id: 3,
    name: "Tarot",
    icon: <StyleIcon />,
    subItems: [
      {
        id: 31,
        name: "What is tarot?",
        icon: <WavingHandIcon />,
        link: links.TAROT_WHAT_IS,
      },
      {
        id: 32,
        name: "Tarot decks",
        icon: <StyleIcon />,
        link: links.TAROT_DECKS,
      },
      {
        id: 33,
        name: "Daily card",
        icon: <TodayIcon />,
        link: links.TAROT_DAILY_CARD,
      },
      {
        id: 34,
        name: "Daily love tarot",
        icon: <FavoriteIcon />,
        link: links.TAROT_DAILY_LOVE_TAROT,
      },
      {
        id: 35,
        name: "Yes no tarot",
        icon: <FlakyIcon />,
        link: links.TAROT_YES_NO_TAROT,
      },
      {
        id: 36,
        name: "One card tarot reading",
        icon: <SdCardIcon />,
        link: links.TAROT_ONE_CARD_TAROT_READING,
      },
    ],
  },
];

const Sidebar: React.FC = () => {
  const location = useLocation();

  const { isCollapsed, toggleCollapse } = useAppContext();
  const [openItems, setOpenItems] = useState<number[]>([]);
  const { logout } = useAuth();
  const [hoveredItem, setHoveredItem] = useState<MenuItem | null>(null);
  const [hoverPosition, setHoverPosition] = useState<{
    top: number;
    left: number;
  } | null>(null);
  const [isHovering, setIsHovering] = useState<boolean>(false);

  const handleClick = (id: number) => {
    setOpenItems((prev) =>
      prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
    );
  };

  const toggleSidebar = () => {
    toggleCollapse();
    setHoveredItem(null);
    setHoverPosition(null);
  };

  const handleMouseEnter = (
    event: React.MouseEvent<HTMLElement>,
    item: MenuItem
  ) => {
    if (isCollapsed) {
      const rect = event.currentTarget.getBoundingClientRect();
      setHoveredItem(item);
      setHoverPosition({ top: rect.top, left: rect.right });
      setIsHovering(true);
    }
  };

  const handleMouseLeave = () => {
    // Introduce a slight delay before hiding the hover item to allow the user to move the mouse over the `div`
    setTimeout(() => {
      if (!isHovering) {
        setHoveredItem(null);
        setHoverPosition(null);
      }
    }, 100);
  };

  const handleInfoMouseEnter = () => {
    setIsHovering(true);
  };

  const handleInfoMouseLeave = () => {
    setIsHovering(false);
    setHoveredItem(null);
    setHoverPosition(null);
  };

  useEffect(() => {
    // check openItems
    const menuItem = menuItems.find(
      (item) =>
        !!item.subItems?.some((subItem) => subItem.link === location.pathname)
    );
    if (menuItem) {
      setOpenItems((prev) => [...prev, menuItem.id]);
    }
  }, [location.pathname]);

  const onLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to logout this user!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        logout();
      }
    });
  };

  return (
    <Drawer
      variant="permanent"
      open={!isCollapsed}
      sx={{
        height: "100vh",
        width: isCollapsed ? 60 : 240,
        flexShrink: 0,
        marginRight: isCollapsed ? "0px" : "10px",
        "& .MuiDrawer-paper": {
          width: isCollapsed ? 60 : 250,
          border: "none",
          boxSizing: "border-box",
          transition: "width 0.3s",
          backgroundColor: "#EDF2F7",
        },
        "& .MuiSvgIcon-root": {
          color: "#2A4365",
        },
        "& .MuiTypography-root": {
          color: "#2A4365",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isCollapsed ? "center" : "flex-end",
          padding: 1,
          ...(isCollapsed ? { flexDirection: "column-reverse" } : {}),
        }}
      >
        <ListItem
          component={Link}
          to="/"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& img": {
              width: isCollapsed ? "32px" : "60px",
            },
          }}
        >
          <img src={LogoIcon} />
        </ListItem>
        <IconButton onClick={toggleSidebar}>
          {isCollapsed ? <MenuIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </Box>
      <List
        sx={{
          height: "calc(100vh - 100px)",
          overflowY: "auto",
        }}
      >
        {/* Logo and Home Link */}

        {menuItems.map((item) => (
          <div key={item.id}>
            <ListItem
              onClick={() => handleClick(item.id)}
              onMouseEnter={(e) => handleMouseEnter(e, item)}
              onMouseLeave={handleMouseLeave}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              {!isCollapsed && <ListItemText primary={item.name} />}
              {!isCollapsed && (
                <IconButton edge="end">
                  {openItems.includes(item.id) ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </IconButton>
              )}
            </ListItem>
            <Collapse
              in={openItems.includes(item.id) && !isCollapsed}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {item.subItems?.map((subItem) =>
                  subItem.link ? (
                    <ListItem
                      key={subItem.id}
                      component={Link}
                      to={subItem.link}
                    >
                      <ListItemIcon color="primary">
                        {subItem.icon}
                      </ListItemIcon>
                      {!isCollapsed && (
                        <ListItemText
                          primary={subItem.name}
                          color="primary"
                          sx={
                            location.pathname === subItem.link
                              ? {
                                  "& span": {
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                  },
                                }
                              : {
                                  "& span": {
                                    fontWeight: "300",
                                    fontSize: "14px",
                                  },
                                }
                          }
                        />
                      )}
                    </ListItem>
                  ) : (
                    <ListItem key={subItem.id}>
                      <ListItemIcon color="primary">
                        {subItem.icon}
                      </ListItemIcon>
                      {!isCollapsed && (
                        <ListItemText primary={subItem.name} color="primary" />
                      )}
                    </ListItem>
                  )
                )}
              </List>
            </Collapse>
          </div>
        ))}

        {/* Logout Button */}
      </List>
      <ListItem
        onClick={() => onLogout()}
        sx={{
          cursor: "pointer",
          "&:hover": {
            "& span": {
              fontWeight: "bold",
            },
          },
        }}
      >
        <ListItemIcon>
          <ExitToAppIcon />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItem>
      {/* Hover Display Div */}
      {hoveredItem && hoverPosition && (
        <div
          style={{
            position: "fixed",
            top: hoverPosition.top,
            left: hoverPosition.left,
            backgroundColor: "#EDF2F7",
            // border: "1px solid #ccc",
            padding: "10px",
            zIndex: 1000,
            // boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
            borderRadius: "4px",
          }}
          onMouseEnter={handleInfoMouseEnter} // Keep the div visible when hovering over it
          onMouseLeave={handleInfoMouseLeave} // Hide when mouse leaves the div
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
            }}
          >
            {hoveredItem.name}
          </Typography>
          {hoveredItem.subItems && (
            <List>
              {hoveredItem.subItems.map((subItem) => (
                <ListItem
                  key={subItem.id}
                  component={Link}
                  to={subItem.link ?? ""}
                >
                  <ListItemIcon color="primary">{subItem.icon}</ListItemIcon>
                  <ListItemText
                    primary={subItem.name}
                    sx={
                      location.pathname === subItem.link
                        ? {
                            "&:hover": {
                              "& span": {
                                fontWeight: "bold",
                              },
                            },
                            "& span": {
                              fontWeight: "bold",
                              fontSize: "14px",
                            },
                          }
                        : {
                            "&:hover": {
                              "& span": {
                                fontWeight: "bold",
                              },
                            },
                            "& span": {
                              fontWeight: "300",
                              fontSize: "14px",
                            },
                          }
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </div>
      )}
    </Drawer>
  );
};

export default Sidebar;
